/**
 * Determine if a color is light or dark to set appropriate text color
 * Returns true if color is light (should use dark text)
 * Returns false if color is dark (should use light text)
 */
export function isLightColor(hexColor: string): boolean {
  // Default to dark text for white background
  if (!hexColor || hexColor.toLowerCase() === '#ffffff') {
    return true;
  }

  // Handle 3-digit hex codes (e.g., #FFF)
  if (hexColor.length === 4) {
    const r = hexColor.charAt(1);
    const g = hexColor.charAt(2);
    const b = hexColor.charAt(3);
    hexColor = `#${r}${r}${g}${g}${b}${b}`;
  }

  // Extract RGB components
  const r = parseInt(hexColor.substring(1, 3), 16);
  const g = parseInt(hexColor.substring(3, 5), 16);
  const b = parseInt(hexColor.substring(5, 7), 16);

  // Calculate luminance using the relative luminance formula
  // Using perceptual weights for RGB: R=0.299, G=0.587, B=0.114
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return true if light (need dark text), false if dark (need light text)
  return luminance > 0.5;
}

/**
 * Get appropriate text color class based on background color
 */
export function getTextColorClass(backgroundColor: string): string {
  return isLightColor(backgroundColor) ? 'text-black' : 'text-white';
}
